import {SquarePenIcon, UploadIcon} from 'lucide-react';
import {Button, Tooltip, TooltipContent, TooltipTrigger} from '@tinct/web-components';
import {Link} from 'react-router-dom';
import {CreateAudienceModal} from '@tinct/web-feature-companies';
import {NEW_CAMPAIGN_DIALOG_HASH} from '@tinct/web-feature-campaigns';
import {useState} from 'react';

interface DashboardHeaderProps {
  workspaceBaseUrl: string;
  lastBrandVersion: unknown;
}

export function DashboardHeader({workspaceBaseUrl, lastBrandVersion}: DashboardHeaderProps) {
  const [isCreateAudienceModalOpen, setIsCreateAudienceModalOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">
        Dashboard
      </h1>
      <div className="flex items-center gap-2">
        <Button variant="outline" className="flex-1 sm:flex-none cursor-pointer"
                onClick={() => setIsCreateAudienceModalOpen(true)}>
          <UploadIcon className="size-4"/>
          <span className="hidden sm:inline">Import audience</span>
          <span className="sm:hidden">Audience</span>
        </Button>
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Button className="flex-1 sm:flex-none" disabled={lastBrandVersion == null} asChild={lastBrandVersion != null}>
                <Link to={{hash: NEW_CAMPAIGN_DIALOG_HASH}} className={'flex items-center justify-center gap-2 m-0 p-0'}>
                  <SquarePenIcon className="size-4"/>
                  <span className="sm:inline">New campaign</span>
                </Link>
              </Button>
            </span>
          </TooltipTrigger>
          {lastBrandVersion == null && (
            <TooltipContent side="top">
              Complete your brand analysis first
            </TooltipContent>
          )}
        </Tooltip>
      </div>
      <CreateAudienceModal
        open={isCreateAudienceModalOpen}
        onOpenChange={setIsCreateAudienceModalOpen}
        completedUrl={`${workspaceBaseUrl}/audiences`}
      />
    </div>
  );
}
